import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { buscarChaveDigitalizacao } from '~/Services/Service';

const formatarMoeda = (valor) =>
  Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

const formatarData = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('pt-BR');
};

const CamposChave = ({ chaveSelecionada, onChangeChave, codigoGrupoEmpresa }) => {
  const [portador, setPortador] = useState('');
  const [sequencia, setSequencia] = useState('');
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    setPortador('');
    setSequencia('');
    onChangeChave(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGrupoEmpresa]);

  const handlePortador = (v) => {
    setPortador(v);
    if (chaveSelecionada) onChangeChave(null);
  };

  const handleSequencia = (v) => {
    setSequencia(v);
    if (chaveSelecionada) onChangeChave(null);
  };

  const handleBuscar = async () => {
    if (!codigoGrupoEmpresa) {
      toast.error('Selecione um Grupo de Empresa primeiro.');
      return;
    }
    const portInt = parseInt(portador, 10);
    const seqInt = parseInt(sequencia, 10);
    if (!portInt || portInt <= 0 || !seqInt || seqInt <= 0) {
      toast.warning('Chave inválida');
      return;
    }
    setCarregando(true);
    try {
      const result = await buscarChaveDigitalizacao(codigoGrupoEmpresa, portInt, seqInt);
      if (!result) {
        toast.info('Nenhum registro encontrado');
        onChangeChave(null);
      } else {
        onChangeChave(result);
      }
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao buscar chave';
      toast.error(msg);
      onChangeChave(null);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Form.Group>
      <Form.Label className="small mb-1 d-block">Chave</Form.Label>
      <Row noGutters>
        <Col xs={5} className="pr-1">
          <Form.Control
            type="number"
            min="1"
            placeholder="Portador"
            value={portador}
            onChange={(e) => handlePortador(e.target.value)}
            disabled={carregando}
          />
        </Col>
        <Col xs={5} className="pr-1">
          <Form.Control
            type="number"
            min="1"
            placeholder="Sequência"
            value={sequencia}
            onChange={(e) => handleSequencia(e.target.value)}
            disabled={carregando}
          />
        </Col>
        <Col xs={2}>
          <Button
            variant="primary"
            block
            onClick={handleBuscar}
            disabled={carregando}
          >
            {carregando ? <Spinner animation="border" size="sm" /> : 'Buscar'}
          </Button>
        </Col>
      </Row>

      {chaveSelecionada && (
        <Card className="mt-2" border="success">
          <Card.Body className="p-2">
            <div className="small">
              <div><strong>Fornecedor:</strong> {chaveSelecionada.fornecedor || '—'}</div>
              <div><strong>Despesa:</strong> {chaveSelecionada.despesa || '—'}</div>
              <div><strong>Data:</strong> {formatarData(chaveSelecionada.data)}</div>
              <div><strong>Vencimento:</strong> {formatarData(chaveSelecionada.vencimento)}</div>
              <div><strong>Pagamento:</strong> {formatarData(chaveSelecionada.data_pagamento)}</div>
              <div><strong>Valor:</strong> {formatarMoeda(chaveSelecionada.valor)}</div>
              {chaveSelecionada.obs1 && <div><strong>Obs1:</strong> {chaveSelecionada.obs1}</div>}
              {chaveSelecionada.obs2 && <div><strong>Obs2:</strong> {chaveSelecionada.obs2}</div>}
              {chaveSelecionada.obs3 && <div><strong>Obs3:</strong> {chaveSelecionada.obs3}</div>}
              {chaveSelecionada.obs4 && <div><strong>Obs4:</strong> {chaveSelecionada.obs4}</div>}
            </div>
          </Card.Body>
        </Card>
      )}
    </Form.Group>
  );
};

export default CamposChave;
